import { Typography, List, Space } from "antd";
import { RightCircleFilled } from "@ant-design/icons";

const { Paragraph, Text, Link } = Typography;

import loginMessageDisplay from "../../assets/login-onboard-message.svg";
import welcomeIcon from "../../assets/frictionlessOnboarding/WelcomePlatform.svg";
import startFreeCreditsIcon from "../../assets/frictionlessOnboarding/StartfreeCredits.svg";
import bestPromptIcon from "../../assets/frictionlessOnboarding/PromptEnvironment.svg";
import onePromptIcon from "../../assets/frictionlessOnboarding/PromptLaunch.svg";
import helpIcon from "../../assets/frictionlessOnboarding/AvailableToAssist.svg";

export const LoginSlides = [
  {
    imageIcon: welcomeIcon,
    image: loginMessageDisplay,
    title: "Welcome to the Unstract Platform!",
    text: (
      <Paragraph>
        Welcome to the cutting edge in structured information extraction.
        Unstract leverages Large Language Models to extract clean,
        well-structured information from even long, complex documents. While you
        save time and money, your business speeds up with the automation!
      </Paragraph>
    ),
  },
  {
    imageIcon: startFreeCreditsIcon,
    image: loginMessageDisplay,
    title: "Start with $10 in free credits!",
    text: (
      <div>
        <Paragraph>
          To make it easy for you, we provide you the following free services
          during your 14-day free trial:
        </Paragraph>
        <List
          size="large"
          itemLayout="horizontal"
          dataSource={[
            "$10 in free credits for the OpenAI GPT4-Turbo LLM",
            "Free OpenAI Embeddings",
            "Free Qdrant Vector Database",
            "Free LLMWhisperer Text Extraction service for up to 100 pages/day",
          ]}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  <RightCircleFilled
                    style={{ color: "green", fontSize: "24px" }}
                  />
                }
                title={
                  <Space direction="vertical" size={0}>
                    <strong>{item}</strong>
                  </Space>
                }
              />
            </List.Item>
          )}
        />
        <Paragraph>
          All these services are pre-configured and ready for you to go! What’s
          more—you can connect your own LLM, Embeddings, Vector DB and Text
          Extraction services as well.
        </Paragraph>
      </div>
    ),
  },
  {
    imageIcon: bestPromptIcon,
    image: loginMessageDisplay,
    title: "The best prompt engineering environment!",
    text: (
      <Paragraph>
        Tired of wrangling prompts in your regular IDE? Prompt Studio was built
        from the ground up for seamless prompt engineering. See outputs from
        various LLMs side-by-side, with extracted values and sample source
        documents for easy comparison. We’ve even included a sample project for
        you to easily get started with.
      </Paragraph>
    ),
  },
  {
    imageIcon: onePromptIcon,
    image: loginMessageDisplay,
    title: "One: Prompt Two: Launch!",
    text: (
      <Paragraph>
        Creating unstructured data-related automation is simple in Unstract.
        Define the prompts needed to extract data for any class of documents in
        a Prompt Studio project. Later, you can launch that project as an API or
        ETL Pipeline to extract data from further documents.
      </Paragraph>
    ),
  },
  {
    imageIcon: helpIcon,
    image: loginMessageDisplay,
    title: "We’re here to help!",
    text: (
      <div>
        <Paragraph>Need help?</Paragraph>
        <List
          size="large"
          itemLayout="horizontal"
          dataSource={[
            <Text key="1">
              We have{" "}
              <Link href="https://docs.unstract.com/" target="_blank">
                awesome documentation
              </Link>
            </Text>,
            <Text key="2">
              <Link href="https://join-slack.unstract.com/" target="_blank">
                Join our Slack community
              </Link>{" "}
              for great conversations on using LLMs in production
            </Text>,
            <Text key="3">
              If you want to see a demo of the Unstract Platform,{" "}
              <Link
                href="https://unstract.com/schedule-a-demo/"
                target="_blank"
              >
                reach out to us here.
              </Link>
            </Text>,
          ]}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  <RightCircleFilled
                    style={{ color: "green", fontSize: "24px" }}
                  />
                }
                title={
                  <Space direction="vertical" size={0}>
                    <strong>{item}</strong>
                  </Space>
                }
              />
            </List.Item>
          )}
        />
      </div>
    ),
  },
];
